<template>
  <div>
    <bs-card class="card-info">
      <bs-table v-bind="{dataLength, loading}" :cols="6">
        <template v-slot:thead>
          <tr>
            <bs-th :label="$t('labels.due_at')" :sortable="resourceState.sort" :col="'due_at'" @click="applySort"></bs-th>
            <bs-th v-if="parseInt(allBookingsState.user) === 0"></bs-th>
            <bs-th :label="$t('labels.customer')"></bs-th>
            <bs-th :label="$tc('labels.task', 0)"></bs-th>
            <th></th>
            <th></th>
          </tr>
        </template>
        <tr v-for="r in resources.data" :key="r.id">
          <td>
            <span v-if="r.multi_day">
              <span>{{ r.due_at | luxon:format('MMM d') }}</span>
              <span> - </span>
              <span>{{ r.end_at | luxon:format('MMM d') }}</span>
            </span>
            <span v-else>{{ r.due_at | luxon:format('ccc MMM d, y h:mma') }}</span>
          </td>
          <td>
            <div class="d-flex justify-content-center">
              <avatar v-for="user in r.users" :key="'ua' + r.id + user.id" class="mr-1" :user="user" />
            </div>
          </td>
          <td :class="auth.can['edit_customers'] ? 'clickable' : ''" @click="auth.can['edit_customers'] ? $router.push({ name: 'Customer', params: { customer: r.customer.id }}) : null">
            <span>
                <span class="font-weight-bold">{{ r.customer.name }}</span><br>
                <small v-if="r.property">{{ r.property.label }}</small>
            </span>
          </td>
          <td>
            <bs-badge v-for="task in r.tasks" :key="'g' + r.id + 't' + task.id" :class="task.complete ? 'badge-success' : 'badge-light'">
              {{ task.label }}
            </bs-badge>
          </td>
          <td class="text-center">
            <bs-badge class="badge-success" v-if="r.completed">
              {{ $t('labels.completed')}}
            </bs-badge>
            <bs-badge class="badge-secondary" v-else>
              {{ $t('labels.pending')}}
            </bs-badge>
          </td>
          <td class="t2">
            <bs-action v-if="r.completed" :icon="['fas', 'eye']" :tip="$t('labels.action_resource', { action: $t('labels.view'), resource: $t('labels.report') })" class="btn-warning" @click="viewReport(r)"></bs-action>
            <bs-action :icon="['fal', 'pencil']" :tip="$t('labels.action_' + camelToSnake(singular($options.name)), { action: $t('labels.edit') })" class="btn-info" @click="update(r)"></bs-action>
          </td>
          <bs-modal :name="'task-group-card-' + r.id" :label="r.customer.name">
            <booking-card :r="r" :collection="'bookings'" @refresh="index()" hideLabel />
          </bs-modal>
        </tr>
      </bs-table>
    </bs-card>
    <bs-modal :name="'report-booking'" :label="$t('labels.report')">
      <booking-report :report="activeBooking" />
    </bs-modal>
    <bs-modal :name="'destroy-' + $options.name" :label="$t('labels.action_' + camelToSnake(singular($options.name)), { action: $t('labels.destroy') })">
      <bs-form :destroy="$t('labels.destroy')" @submit="destruction">
        {{ $t('messages.delete', { resource: $t('labels.customer') }) }}
      </bs-form>
    </bs-modal>
    <portal to="app-footer">
      <pagination :data="resources" :state="resourceState" @pushPage="index" :filters="filters"></pagination>
    </portal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { resourceControl } from '../../mixins/resourceControl'

export default {
  name: 'Bookings',
  mixins: [resourceControl],
  data () {
    return {
      icon: ['fal', 'calendar-alt'],
      loading: false,
      activeId: null,
      activeBooking: {},
      resource: {
        name: ''
      },
      filters: {
        state: true
      }
    }
  },
  computed: {
    ...mapState({
      auth: state => state.auth,
      resources: state => state.bookings,
      submitting: state => state.submitting,
      resourceState: state => state.bookingsState,
      allBookingsState: state => state.allBookingsState
    }),
    dataLength () {
      let length = 0
      if (this.resources.data) length = this.resources.data.length
      return Math.max(this.resourceState.tableRows - length, 0)
    }
  },
  watch: {
    'allBookingsState.user': function () {
      if (!this.loading) this.index(1)
    },
    'allBookingsState.dateFrom': function () {
      if (!this.loading) this.index(1)
    }
  },
  methods: {
    index (page, count, filters) {
      this.handleState(page, count, filters)
      this.loading = true
      this.$store.dispatch('index', {
        collection: this.$options.name,
        params: {
          from: this.allBookingsState.dateFrom,
          user: this.allBookingsState.user
        },
        data: {
          icon: ['fal', 'calendar-alt']
        }
      }).then(() => {
        this.loading = false
      })
    },
    update (o) {
      this.$modal.show('task-group-card-' + o.id)
    },
    viewReport (r) {
      this.activeBooking = r
      this.$modal.show('report-booking')
    }
  }
}
</script>
